import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "articles__menu-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "articles__menu-header" }
const _hoisted_4 = { class: "articles__menu-list" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "articles__menu-item"
        }, [
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.openInfoModal(article)),
            class: "articles__menu-item-btn",
            "aria-label": "Otwórz szczegóły artykułu {{ article.name }}"
          }, [
            _createElementVNode("span", {
              class: "articles__menu-item-icon",
              style: _normalizeStyle(`mask: url(data:image/svg+xml;base64,${article.icon}) no-repeat center; mask-size: contain;`)
            }, null, 4),
            _createTextVNode(" " + _toDisplayString(article.name), 1)
          ], 8, _hoisted_2)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_translated_text_component, { translation: "links_header" })
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createElementVNode("a", {
            href: link.url,
            target: "_blank",
            class: "articles__menu-item-btn"
          }, [
            _createElementVNode("span", {
              class: "articles__menu-item-icon",
              style: _normalizeStyle(`mask: url(data:image/svg+xml;base64,${link.icon}) no-repeat center; mask-size: contain;`)
            }, null, 4),
            _createTextVNode(" " + _toDisplayString(link.name), 1)
          ], 8, _hoisted_5)
        ]))
      }), 128))
    ])
  ], 64))
}